export const ALLOW_FILE_DEGREE_TYPES = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'application/pdf',
]

export const DEGREE_MAX_FILE_SIZE = 5